export default __webpack_public_path__ + "static/media/waterfowl@2x.b3e0e4b7.jpg";